import React from 'react';
import { Button } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Box, Text } from 'rebass/styled-components';
import { useLinkedIn } from 'react-linkedin-login-oauth2';

import { useSignIn } from '../../../hooks/useSignIn';
import { useSignUp } from '../../../hooks/useSignUp';
import { LinkedInIcon } from './components/linkedinIcon';

export const LinkedInSignInButton = ({
  containerProps,
  mode,
  params,
  onSuccess,
  onError,
  isInvite,
  ...buttonProps
}) => {
  const { signIn, isLoading: isLoadingSignIn } = useSignIn({ isInvite });
  const { signUp, isLoading: isLoadingSignUp } = useSignUp();

  const onSuccessResponse = (code) => {
    const method = mode === 'sign-in' ? signIn : signUp;

    method({ code, identityProvider: 'linkedin', ...params })
      .then(onSuccess)
      .catch((error) => onError({ ...error, provider: 'linkedin' }));
  };

  const onErrorResponse = (error) => {
    if (!['user_closed_popup', 'user_cancelled_authorize'].includes(error?.error)) {
      onError({ ...error, provider: 'linkedin' });
    }
  };

  const { linkedInLogin } = useLinkedIn({
    clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
    redirectUri: `${window.location.origin}/app/linkedin`,
    scope: 'openid email profile',
    onSuccess: onSuccessResponse,
    onError: onErrorResponse,
  });

  return (
    <Box {...containerProps}>
      <Button
        variant="secondary"
        icon={LinkedInIcon}
        width="100%"
        loading={isLoadingSignIn || isLoadingSignUp}
        sx={{ alignItems: 'center', justifyContent: 'center', gap: '80px' }}
        {...buttonProps}
        onClick={linkedInLogin}
      >
        <Text pl="4px">Continue with LinkedIn</Text>
      </Button>
    </Box>
  );
};

LinkedInSignInButton.propTypes = {
  containerProps: PropTypes.object,
  mode: PropTypes.oneOf(['sign-in', 'sign-up']),
  params: PropTypes.object,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  isInvite: PropTypes.bool,
};

LinkedInSignInButton.defaultProps = {
  containerProps: {},
  mode: 'sign-in',
  params: {},
  onSuccess: () => {},
  onError: () => {},
  isInvite: false,
};
